import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';
import LegalPageLayoutV2 from '@/components/marketing/legal/v2/LegalPageLayoutV2';

export default function Terms() {
  const { t } = useTranslation('marketing');

  return (
    <>
      <SEOHead
        title="Conditions générales d'utilisation — Velko POS"
        description="CGU Velko POS : souscription, tarification, obligations, propriété des données, résiliation. Juridiction camerounaise et OHADA."
        path="/conditions-utilisation"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: "Conditions d'utilisation", path: '/conditions-utilisation' },
        ]}
      />
      <LegalPageLayoutV2
        kind="terms"
        subtitle={t('terms.heroSubtitle')}
        lastUpdated={t('terms.lastUpdated')}
        content={t('terms.content')}
        contactTitle="Une clause te bloque ?"
        contactDesc="On est ouverts à la négociation sur les points substantiels, surtout pour les plans Business. Écris-nous."
      />
    </>
  );
}
